/*
 * Small accessibility fixes for app markup we don't control (loaded on product pages only).
 * Judge.me's review sort menu has no label; give it one once the widget has loaded. Nothing else changes.
 */
(function () {
  var label = 'Sort reviews';
  function fix() {
    document.querySelectorAll('select.jdgm-sort-dropdown').forEach(function (s) {
      if (!s.getAttribute('aria-label') && !(s.id && document.querySelector('label[for="' + s.id + '"]'))) s.setAttribute('aria-label', label);
    });
  }
  fix();
  if (!('MutationObserver' in window)) return;
  var obs = new MutationObserver(fix);
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 20000);
})();
